import { render } from "./toast-header.vue?vue&type=template&id=8d1b410a"
import script from "./toast-header.vue?vue&type=script&lang=js"
export * from "./toast-header.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/d/git/workshop/social-friendsquads/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__